const CART_COUNT_SELECTOR = '.site-masthead__cart-count';
const WINDOW_MS = 8000;

async function refreshCartCount() {
  try {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const cart = await res.json();

    let badge = document.querySelector(CART_COUNT_SELECTOR);
    if (!badge) {
      const icon = document.querySelector('.site-masthead__action--cart .site-masthead__action-icon');
      if (!icon) return;
      badge = document.createElement('span');
      badge.className = 'site-masthead__cart-count';
      icon.appendChild(badge);
    }
    badge.textContent = String(cart.item_count);
    badge.hidden = cart.item_count === 0;
  } catch {

  }
}

function wire(form) {
  if (!(form instanceof HTMLFormElement)) return;

  const addBtn = form.querySelector('[data-hd-atc-add]');
  const stepper = form.querySelector('[data-hd-atc-stepper]');
  const dec = form.querySelector('[data-hd-atc-dec]');
  const inc = form.querySelector('[data-hd-atc-inc]');
  const count = form.querySelector('[data-hd-atc-count]');
  const variantId = form.dataset.variantId || form.querySelector('[name="id"]')?.value;
  if (!addBtn || !stepper || !variantId) return;

  let qty = 0;
  let timer;
  let hovering = false;

  const label = (n) => `${n} in cart`;

  const showAdd = () => {
    window.clearTimeout(timer);
    stepper.hidden = true;
    stepper.classList.remove('is-counting');
    addBtn.hidden = false;
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Cart';
  };

  const startCountdown = () => {
    window.clearTimeout(timer);

    stepper.classList.remove('is-counting');
    void stepper.offsetWidth;
    stepper.classList.add('is-counting');
    if (hovering) return;
    timer = window.setTimeout(showAdd, WINDOW_MS);
  };

  const showStepper = () => {
    addBtn.hidden = true;
    stepper.hidden = false;
    if (count) count.textContent = label(qty);
    startCountdown();
  };

  stepper.addEventListener('pointerenter', () => {
    hovering = true;
    window.clearTimeout(timer);
    stepper.classList.add('is-paused');
  });
  stepper.addEventListener('pointerleave', () => {
    hovering = false;
    stepper.classList.remove('is-paused');
    if (!stepper.hidden) startCountdown();
  });
  stepper.addEventListener('focusin', () => {
    hovering = true;
    window.clearTimeout(timer);
    stepper.classList.add('is-paused');
  });
  stepper.addEventListener('focusout', (event) => {
    if (event.relatedTarget instanceof Node && stepper.contains(event.relatedTarget)) return;
    hovering = false;
    stepper.classList.remove('is-paused');
    if (!stepper.hidden) startCountdown();
  });

  const busy = (on) => {
    [dec, inc].forEach((b) => b && (b.disabled = on));
  };

  async function addOne() {
    busy(true);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) return false;
      const line = await res.json();
      qty = typeof line.quantity === 'number' ? line.quantity : qty + 1;
      await refreshCartCount();
      return true;
    } catch {
      return false;
    } finally {
      busy(false);
    }
  }

  async function setQty(next) {
    busy(true);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: next }),
      });
      if (!res.ok) return false;
      const cart = await res.json();
      const line = cart.items?.find((i) => String(i.variant_id) === String(variantId));
      qty = line ? line.quantity : 0;
      await refreshCartCount();
      return true;
    } catch {
      return false;
    } finally {
      busy(false);
    }
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    const ok = await addOne();
    if (!ok) {

      form.submit();
      return;
    }
    showStepper();
  });

  inc?.addEventListener('click', async () => {
    if (await addOne()) {
      if (count) count.textContent = label(qty);
      startCountdown();
    }
  });

  dec?.addEventListener('click', async () => {
    const next = Math.max(0, qty - 1);
    if (!(await setQty(next))) return;
    if (qty <= 0) {
      showAdd();
      return;
    }
    if (count) count.textContent = label(qty);
    startCountdown();
  });
}

document.querySelectorAll('[data-hd-atc-form]').forEach(wire);
